<template>
    <section class="main-space-and-equipment">
        <v-container>
            <ul class="main-space-and-equipment__items">
                <li>
                    <tit-primary class="main-space-and-equipment__title">공간과 장비</tit-primary>
                    <v-row class="row--sm">
                        <v-col v-for="(item, index) in items" :key="index" cols="6">
                            <v-card :to="item.path" flat tile class="space-card">
                                <v-img :src="item.icon" alt="" />
                                <v-card-title>
                                    <u-tit-default class="tit--sm">
                                        {{ item.name }}
                                    </u-tit-default>
                                </v-card-title>
                                <v-card-text>
                                    <txt-primary class="txt--lg">바로가기</txt-primary>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </li>
                <li>
                    <v-row align="center" no-gutters class="h-100">
                        <v-col>
                            <txt-primary class="txt--xl line-height-15 txt--dark">
                                봉제공장과 의류업체 간의 <br />
                                매칭 지원 플랫폼
                            </txt-primary>
                            <router-link to="/donggori/signup" class="donggori-link">
                                <u-tit-default class="tit--lg">동고리 가입 안내<v-icon large>mdi-chevron-right</v-icon></u-tit-default>
                            </router-link>
                        </v-col>
                        <v-col cols="auto">
                            <v-img src="/images/icon/icon-donggori.svg" alt="" class="icon-donggori" />
                        </v-col>
                    </v-row>
                    <a href=""></a>
                </li>
            </ul>
        </v-container>
    </section>
</template>

<script>
import TitPrimary from "@/components/publish/parents/typography/tit-primary.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

export default {
    components: {
        TitPrimary,
        UTitDefault,
        TxtPrimary,
    },
    data() {
        return {
            items: [
                {
                    name: "공간 안내",
                    icon: "/images/icon/icon-space.svg",
                    path: "/facility-space/YONGSIN",
                },
                {
                    name: "장비 안내",
                    icon: "/images/icon/icon-equipment.svg",
                    path: "/studio-equipment/YONGSIN?code=STUDIO",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.main-space-and-equipment {
    &__items {
        z-index: 1;
        @media (min-width: 1024px) {
            display: flex;
        }
        > li {
            position: relative;
            padding: 16px;
            &::after {
                content: "";
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: -1;
                background-repeat: no-repeat;
                background-size: cover;
                @media (min-width: 1024px) {
                    width: 100vw;
                }
            }
            &:first-child {
                color: #fff;
                @media (min-width: 1024px) {
                    flex-basis: calc(524 / 1200 * 100%);
                    padding: 0 60px 0 0;
                }
                &::after {
                    right: 0;
                    background-image: url(/images/main/bg-space.webp);
                    @media (min-width: 1024px) {
                        width: calc(884 / 1920 * 100vw);
                    }
                }
                .main-space-and-equipment__title {
                    margin: 0 0 16px;
                    @media (min-width: 1024px) {
                        margin: 60px 0 40px;
                    }
                }
            }
            &:last-child {
                padding: 36px 16px;
                @media (min-width: 1024px) {
                    flex-basis: calc(676 / 1200 * 100%);
                    padding: 0 0 0 60px;
                }
                &::after {
                    left: 0;
                    background-image: url(/images/main/bg-donggori.webp);
                }
                .icon-donggori {
                    max-width: 0;
                    @media (min-width: 375px) {
                        max-width: 60px;
                    }
                    @media (min-width: 425px) {
                        max-width: 100px;
                    }
                    @media (min-width: 576px) {
                        max-width: 204px;
                    }
                }
            }
        }
    }
}
.space-card {
    text-align: center;
    padding: 20px 0;
    transition: color 0.2s ease-in-out;
    @media (min-width: 768px) {
        padding: 36px 0;
    }
    .v-image {
        max-width: 40px;
        margin: 0 auto;
        @media (min-width: 768px) {
            max-width: 50px;
        }
        @media (min-width: 1024px) {
            max-width: 80px;
        }
    }
    .v-card {
        &__title,
        &__text {
            padding-top: 0;
            padding-bottom: 0;
        }
        &__title {
            justify-content: center;
            margin-top: 12px;
            @media (min-width: 768px) {
                margin-top: 16px;
            }
        }
    }
    &:hover {
        color: var(--v-primary-base);
    }
}
.donggori-link {
    display: inline-block;
    margin-top: 10px;
    line-height: 1.5;
    transition: color 0.2s ease-in-out;
    .v-icon {
        color: inherit;
        transition: all 0.2s ease-in-out;
    }
    &:hover {
        color: var(--v-primary-base);
        .v-icon {
            transform: translateX(4px);
        }
    }
}
</style>
